import { render, staticRenderFns } from "./GroupStatisticTemplateEdit.vue?vue&type=template&id=3b068d2a"
import script from "./GroupStatisticTemplateEdit.vue?vue&type=script&lang=js"
export * from "./GroupStatisticTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports